
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termos-de-uso",
      function () {
        return require("private-next-pages/termos-de-uso.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termos-de-uso"])
      });
    }
  